import React from 'react'
import useTranslations, { TFunction } from './useTranslations'

interface WithTranslationProps {
  t?: TFunction
  lang?: string
}

const withTranslations = <T,>(
  WrappedComponent: React.ComponentType<T>
): React.ComponentType<T & WithTranslationProps> => {
  const WithTranslations = (props) => {
    const translationsContext = useTranslations()

    return (
      <WrappedComponent
        {...props}
        t={translationsContext.t}
        lang={translationsContext.lang}
      />
    )
  }

  return WithTranslations
}

export default withTranslations
